import { render, staticRenderFns } from "./instructions-edit-modal.vue?vue&type=template&id=524a7543&scoped=true&"
import script from "./instructions-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./instructions-edit-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a7543",
  null
  
)

export default component.exports